import { render } from "./DemoCrudIntForm.vue?vue&type=template&id=2bffd49c&scoped=true"
import script from "./DemoCrudIntForm.vue?vue&type=script&lang=js"
export * from "./DemoCrudIntForm.vue?vue&type=script&lang=js"

import "./DemoCrudIntForm.vue?vue&type=style&index=0&id=2bffd49c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bffd49c"]])

export default __exports__